import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const PriceWin = (props) => {
  const data = useStaticQuery(graphql`
    query {
      priceWin: file(
        relativePath: {
          eq: "components/pages/HiringPage/Sections/GallerySection/images/price-win.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 618, maxHeight: 445, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  return <Img fluid={data.priceWin.childImageSharp.fluid} {...props} />
}

export default PriceWin
